/* js/fixedTopBanner.js */


jQuery(document).ready(function ($) {
if ($(".mainContent").length) {

    var fixedTopHeight = $('.fixedTop').outerHeight();

    $('.fixedTop-space').css('margin-bottom', fixedTopHeight);

    $(window).resize(function () {
        var fixedTopHeight = $('.fixedTop').outerHeight();
        $('.fixedTop-space').css('margin-bottom', fixedTopHeight);
    });
}


if ($(".mainContent").length) {


    var distance = $('.mainContent').offset().top - 50,
        $window = $(window);

    $window.scroll(function () {
        if ($window.scrollTop() >= distance) {
            $('body').addClass('mainContent-is-top');
        } else {
            $('body').removeClass('mainContent-is-top');
        }
    });

}


    if ($(".fixedTopCarousel-video")[0]){
        var headHeight = $('.headerMain-toolBar').height();
        $('body').addClass('has-vid-banner').css('padding-top', headHeight - 6);


        $( window ).resize(function() {
            var headHeight = $('.headerMain-toolBar').height();
            $('body').addClass('has-vid-banner').css('padding-top', headHeight - 6);
        });


    }



});



